import { Action, configureStore, Middleware, ThunkAction } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'
import { persistedReducer } from './reducer'
import { thunk } from 'redux-thunk'
import { practitionerApiRtk } from './api/practitionerApi'
import { userApiRtk } from './api/userApi'
import { patientApiRtk } from './api/patientApi'
import { deviceApiRtk } from './api/deviceApi'
import { contactApiRtk } from './api/contactApi'
import { msgGwApiRtk } from './api/msgGwApi'
import { codeApiRtk } from './api/codeApi'
import { interopApiRtk } from './api/interopApi'
import { localDocumentsApiRtk } from './localDocuments'
import { documentApiRtk } from './api/documentApi'
//import { logger } from 'redux-logger'

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(
      codeApiRtk.middleware,
      interopApiRtk.middleware,
      practitionerApiRtk.middleware,
      userApiRtk.middleware,
      deviceApiRtk.middleware,
      patientApiRtk.middleware,
      contactApiRtk.middleware,
      msgGwApiRtk.middleware,
      localDocumentsApiRtk.middleware,
      documentApiRtk.middleware,
      thunk as Middleware<unknown, unknown>,
      // Add your own middleware here. For example, you can add a logger:
      //logger,
    ),
})

export const persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
